/**
 * RidesMatchesService
 * Rider-side driver matching for an event + route + party composition.
 * Route: rides/api/rides/matches
 */
import { BaseService } from '../base/BaseService';
import { unwrapRidesResponse as unwrap } from './unwrapRidesResponse';
/** Matching service (JWT). The sex rule and seat filter run server-side; hidden counts explain gaps. */
export class RidesMatchesService extends BaseService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? RidesMatchesService.DEFAULT_SERVICE_PATH,
            basePath: RidesMatchesService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    /** GET api/rides/matches?eventId&collectionLocationId&dropOffLocationId&maleCount&femaleCount&forMinor&serviceTimeId */
    async find(query) {
        return unwrap(await this.findRaw(query), 'Failed to find matching drivers');
    }
    findRaw(query) {
        return this.http.get(this.buildUrlWithParams(undefined, {
            eventId: query.eventId,
            collectionLocationId: query.collectionLocationId,
            dropOffLocationId: query.dropOffLocationId,
            maleCount: query.maleCount,
            femaleCount: query.femaleCount,
            forMinor: query.forMinor,
            serviceTimeId: query.serviceTimeId,
        }));
    }
}
RidesMatchesService.DEFAULT_SERVICE_PATH = 'rides';
RidesMatchesService.BASE_PATH = 'api/rides/matches';
//# sourceMappingURL=RidesMatchesService.js.map